<div class="timer-wrapper">
  <svg class="timer-svg" viewBox="0 0 80 80">
    <!-- Background circle -->
    <circle cx="40" cy="40" r="36" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="4"/>
    <!-- Progress circle -->
    <circle
      cx="40" cy="40" r="36"
      fill="none"
      [attr.stroke]="timerColor"
      stroke-width="4"
      stroke-linecap="round"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="dashOffset"
      class="progress-ring"
      transform="rotate(-90 40 40)"/>
  </svg>
  <span class="timer-text" [style.color]="timerColor">{{value | arabicNumber:currLang}}</span>
</div>
